import get from 'lodash/get';
import upperFirst from 'lodash/upperFirst';
import { IDS } from '../../../../constants/ids';
import { PROFILE_FIELDS } from '../../../../constants/strings';
import { LENGTH_VALUES } from '../../../../constants/validations';
import { getPhoneWithoutUSCode } from '../../../../utils/getPhone';

export function getFieldsEmergencyContactSection(formatMessage, profile) {
  const emergencyContact =
    get(profile, 'primaryPatientProfile.emergencyContactAttributes') || {};
  return [
    {
      fieldName: 'emergencyFirstName',
      id: IDS.FORM_FIELDS.FIRST_NAME,
      value: emergencyContact.firstName,
      limit: LENGTH_VALUES.FIRST_NAME.MAX,
      name: formatMessage(PROFILE_FIELDS.fieldNames.firstName),
    },
    {
      fieldName: 'lastName',
      id: IDS.FORM_FIELDS.LAST_NAME,
      value: emergencyContact.lastName,
      limit: LENGTH_VALUES.LAST_NAME.MAX,
      name: formatMessage(PROFILE_FIELDS.fieldNames.lastName),
    },
    {
      type: 'select',
      fieldName: 'relation',
      id: IDS.FORM_FIELDS.RELATION,
      value: upperFirst(emergencyContact.relation),
      name: formatMessage(PROFILE_FIELDS.fieldNames.relation),
    },
    {
      type: 'number',
      fieldName: 'phoneNumber',
      id: IDS.FORM_FIELDS.PHONE_NUMBER,
      limit: LENGTH_VALUES.PHONE_NUMBER.MAX,
      value: getPhoneWithoutUSCode(emergencyContact.phoneNumber),
      name: formatMessage(PROFILE_FIELDS.fieldNames.mobilePhone),
    },
    {
      fieldName: 'email',
      id: IDS.FORM_FIELDS.EMAIL,
      value: emergencyContact.email,
      name: formatMessage(PROFILE_FIELDS.fieldNames.email),
    },
  ];
}



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/EmergencyContact/utils/getFieldsEmergencyContactSection.js